import { Box, Button, Checkbox, Flex, Heading, Input, InputGroup, InputRightElement, Link, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

// Components
import enviroments from "../../Services/enviroments";
import SlideModal from "../Slide/SlideModal";

// Icons
import { IconCheck, IconCallPerson, IconError } from "../../Assets/GENERALES/Icons"

const FormularioDown = () => {
    const [acceptedComunicaciones, setAcceptedComunicaciones] = useState(true);
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [colorBorder, setColorBorder] = useState('#E4002B');
    const [loadingButton, setLoadinButton] = useState(false);
    const [viewIconRight, setViewIconRight] = useState('');
    const [valuePhone, setValuephone] = useState('');
    const [accepted, setAccepted] = useState(true);
    const [id, setId] = useState('');

    let exprecionRegular = /^\+?\d*$/;

    const location = useLocation();

    const handleChangeInput = (value) => {
        if (value.startsWith("+1868") && exprecionRegular.test(value)) {
            setValuephone(value);
            if (value.length > 13 || value.length < 13 || value.length !== 4) {
                setViewIconRight('Error');
                setColorBorder('#DB110A');
            } if (value.length === 12) {
                setViewIconRight('Success');
                setColorBorder('#1EA67B');
            }
        }
    };

    useEffect(() => {
        if (location.pathname === `${enviroments.urlBase}/`) { setId('Form_Flotante'); };
    }, [location]);

    !loadingButton && openSlideModal && setLoadinButton(true);
    loadingButton && !openSlideModal && setLoadinButton(false);

    return (
        <>
            {/* Formulario */}
            <Flex w='100%' justifyContent='center' maxWidth='1700px' zIndex='2' pos='fixed' bottom='0' bg='#EFECEC' p='5' borderTopRadius={['0', '0', '12px', '12px', '12px']} flexDir={['column', 'column', 'row', 'row', 'row']}>
                <Flex alignItems='center' w={['100%', '100%', '30%', '30%', '30%']}>
                    <Box display={['flex', 'flex', 'none', 'none', 'none']}>
                        <IconCallPerson color='#E4032C' size={'40px'} />
                    </Box>
                    <Box display={['none', 'none', 'flex', 'flex', 'flex']}>
                        <IconCallPerson color='#E4032C' size={'60px'} />
                    </Box>
                    <Box>
                        <Heading color='#E4032C' fontSize={['14px', '14px', '20px', '20px', '20px']} className="Title" fontWeight='500'>
                            Any questions?
                        </Heading>
                        <Heading className="General" fontSize={['14px', '14px', '20px', '20px', '20px']}>
                            We'll help you sign up
                        </Heading>
                    </Box>
                </Flex>

                <Flex w={['100%', '100%', '60%', '60%', '60%']} alignItems='center' gap='4' flexDirection={['column', 'column', 'row', 'row', 'row']}>
                    <Box px={[0, 0, 6, 6, 6]} w={['95%', '95%', '70%', '70%', '70%']}>
                        <Text className="Subtitle" mt={[2,2,2,0,0]} fontSize={['xs','xs','xs','md','md']}>Enter your number</Text>
                        <InputGroup bg='white' size={['sm','sm','sm','md','md']}>
                            <Input className="General" maxLength='12' value={valuePhone} borderBottom={viewIconRight !== '' && `2px solid ${colorBorder}`} onBlur={() => valuePhone === '+1868' && setValuephone('')} onChange={(e) => handleChangeInput(e.target.value)} borderRadius='6px' placeholder='Example: 914235424' onFocus={() => valuePhone === '' && setValuephone('+1868')} _focusVisible={{ variant: 'flushed', bg: '#F3F5FF', borderBottom: `2px solid ${colorBorder}` }} />
                            {
                                viewIconRight !== '' &&
                                <InputRightElement>
                                    {
                                        viewIconRight === 'Error' ? <IconError size='20px' /> : <IconCheck size='20px' />
                                    }
                                </InputRightElement>
                            }
                        </InputGroup>
                        <Checkbox mt='2' size='sm' isChecked={accepted} onChange={(e) => setAccepted(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: accepted ? '#E4032C' : 'white', borderColor: '#E4032C' }, '_checked': { '> span:first-of-type': { bg: '#E4032C', borderColor: '#E4032C' } } }}>
                            <Text className='General' fontSize='x-small'>
                                I have read understood and agreed to <Link href='#' target='_blank' color='#E4032C' textDecoration='underline'>Digicel's Privacy Notice</Link>
                            </Text>
                        </Checkbox>
                        <Checkbox mt='2' size='sm' isChecked={acceptedComunicaciones} onChange={(e) => setAcceptedComunicaciones(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: acceptedComunicaciones ? '#E4032C' : 'white', borderColor: '#E4032C' }, '_checked': { '> span:first-of-type': { bg: '#E4032C', borderColor: '#E4032C' } } }}>
                            <Text className='General' fontSize='x-small'>
                                I accept the <Link href='https://corporate.digicelgroup.com/es/terms-of-use' target='_blank' color='#E4032C' textDecoration='underline'>Terms and conditions</Link> and <Link href='https://corporate.digicelgroup.com/en/legal/acceptable-use-policy' target='_blank' color='#E4032C' textDecoration='underline'>Data privacy policy</Link>
                            </Text>
                        </Checkbox>
                    </Box>
                    <Button bg='#E4032C' isLoading={loadingButton} loadingText='Cargando...' borderRadius='30px' id={id} isDisabled={viewIconRight === '' || viewIconRight === 'Error' || !accepted} onClick={() => setOpenSlideModal(true)} mt='0' color='white' w={['95%', '95%', '40%', '40%', '40%']} _hover={{ color: '#E4032C', border: '2px solid #E4032C', bg: 'transparent' }}>
                        I want you to call me
                    </Button>
                </Flex>
            </Flex>

            {
                openSlideModal &&
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal
                        setOpenSlideModal={setOpenSlideModal}
                        openSlideModal={openSlideModal}
                        submitInitial={true}
                        valuePhoneInitial={valuePhone}
                        plan='Form_Flotante'
                        id='Form_Flotante'
                        setValuePhoneInitial={setValuephone}
                        setColorBorderInitial={setColorBorder}
                        setViewIconRightInitial={setViewIconRight}
                    />
                </Box>
            }
        </>
    )
}

export default FormularioDown;